export const roughlyToPlain = (obj: any) => JSON.parse(JSON.stringify(obj));
